import { Box, Stack } from '@mui/material';
import Features from '../../components/Features';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Hero from '../../components/Hero';
import Insurance from '../../components/Insurance';
import Pricing from '../../components/Pricing';
import Testimonials from '../../components/Testimonials';

const FindABotel = () => {
  return (
    <Stack direction="column">
      <Box sx={{ position: 'relative' }}>
        <Header />
        <Hero />
      </Box>
      <Stack 
        direction="column" 
        spacing={{ xs: 2, sm: 3, md: 4 }}
        sx={{
          backgroundImage: 'url(/images/pricing-bg.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: { xs: 'scroll', md: 'fixed' },
          backgroundColor: 'rgba(32, 39, 45, 0.8)',
          px: { xs: 1, sm: 2, md: 3 }
        }}
      >
        <Features />
        <Pricing />
      </Stack>
      <Insurance />
      <Testimonials />
      <Footer />
    </Stack>
  );
};

export default FindABotel; 